export default __webpack_public_path__ + "static/media/undraw_secure_login_pdn4.58c04f40.svg";